'use strict';

module.exports = {
  element: null
};



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/src/common/dom.js
// module id = 67
// module chunks = 0